<template>
    <div class="dashboard">
        <table-and-mapa-solicitacoes ref="tableAndMapaSP"></table-and-mapa-solicitacoes>
        <ranking-sub-orgao id="rankingSub" ref="rankingSub" filtro="sub" :footerText="ref"></ranking-sub-orgao>
        <ranking-sub-orgao id="rankingOrgao" ref="rankingOrgao" filtro="orgao" :footerText="ref"></ranking-sub-orgao>
    </div>
</template>

<script>
import _ from 'lodash'
import MetodosGlobais from '@/utils/MetodosGlobais'
import AutoUpdate from '@/services/AutoUpdate'
import Constantes from '@/utils/ConstantesGlobais'
import CorUtil from '@/utils/CorUtils'
import TableAndMapaSolicitacoes from '@/components/statistics/charts/TableAndMapaSolicitacoes'
import SolicitacoesBarTable from '@/components/statistics/charts/SolicitacoesBarTable'
import RankingSubOrgao from '@/components/statistics/charts/RankingSubOrgao'

export default {
  name: 'servicos-solicitados',
  mixins: [AutoUpdate],
  components: {
    'table-and-mapa-solicitacoes': TableAndMapaSolicitacoes,
    'bar-table-regiao-orgao': SolicitacoesBarTable,
    'ranking-sub-orgao': RankingSubOrgao,
  },
  data () {
    return {

    }
  },

  mounted () {
    this.buscarTopServicosRegiaoUltimoMes()
    this.buscarTopServicosRegiaoUltimoSemestre()
    this.buscarTopServicosRegiaoUltimoMesFechado()
    this.buscarTopServicosRegiaoUltimoSemestreFechado()
    this.autoUpdate(this.buscarTopServicosRegiaoUltimoMes, null, 'buscarTopServicosRegiaoUltimoMes')
    this.autoUpdate(this.buscarTopServicosRegiaoUltimoSemestre, null, 'buscarTopServicosRegiaoUltimoSemestre')
    this.autoUpdate(this.buscarTopServicosRegiaoUltimoMesFechado, null, 'buscarTopServicosRegiaoUltimoMesFechado')
    this.autoUpdate(this.buscarTopServicosRegiaoUltimoSemestreFechado, null, 'buscarTopServicosRegiaoUltimoSemestreFechado')
    Promise.all([
      this.$store.dispatch('servicos156/buscarNaoGeorreferenciados', { intervalo: 'ULTIMO_MES' }),
      this.$store.dispatch('servicos156/buscarNaoGeorreferenciados', { intervalo: 'ULTIMO_SEMESTRE' }),
      this.$store.dispatch('servicos156/buscarNaoGeorreferenciados', { intervalo: 'ULTIMO_MES_FECHADO' }),
      this.$store.dispatch('servicos156/buscarNaoGeorreferenciados', { intervalo: 'ULTIMO_SEMESTRE_FECHADO' }),
    ])
      .then(
        (respostas) => {
          this.$refs.tableAndMapaSP.setFooterText(respostas)
          
          this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
          this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
          this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
          
          // Atribui a um footer text dentro do compoente
          // TODO : analisar o ciclo de vida do compoente para definir o footer, como PROPS não deu certo.
          this.$refs.tableAndMapaSP.footerText = this.ref
          this.$refs.rankingSub.footerText = this.ref
          this.$refs.rankingOrgao.footerText = this.ref

        })
  },
  methods: {
    buscarTopServicosRegiaoUltimoMes () {
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: null/* Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST */, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas' })
        .then((retorno) => {
          this.$refs.tableAndMapaSP.updateDadosUltimos30Dias(retorno.data)
        })
    },
    buscarTopServicosRegiaoUltimoSemestre () {
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: null/* Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST */, intervalo: 'ULTIMO_SEMESTRE' })
        .then((retorno) => {
          this.$refs.tableAndMapaSP.updateDadosUltimos180Dias(retorno.data)
        })
    },
    buscarTopServicosRegiaoUltimoMesFechado () {
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: null/* Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST */, intervalo: 'ULTIMO_MES_FECHADO', ordenacao: 'recebidas' })
        .then((retorno) => {
          this.$refs.tableAndMapaSP.updateDadosUltimoMesFechado(retorno.data)
        })
    },
    buscarTopServicosRegiaoUltimoSemestreFechado () {
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: null/* Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST */, intervalo: 'ULTIMO_SEMESTRE_FECHADO' })
        .then((retorno) => {
          this.$refs.tableAndMapaSP.updateDadosUltimoSemestreFechado(retorno.data)
        })
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
